// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1gyOm","content":"LoadingAlert_content__oz_rN"};